import React, { useState, useCallback } from 'react';

import { features } from '../utils/contentProvider';

const Feature = () => {
  const [featureActive, setFeatureActive] = useState(0);

  const toggleFaqAccordion = useCallback(
    (id) => () => {
      setFeatureActive(() => id);
    },
    [],
  );

  return (
    <section className="feature" id="cliphire-features">
      <div className="small-container">
        <div className="flex-row no-margin">
          <div className="feature-col">
            <h5 className="yellow-heading ">More Features</h5>
            <h3>The fastest, easiest path to “you’re hired”</h3>
            <div className="accordian-block">
              {features.map(({ id, h, b, logo, img }) => (
                <div
                  key={id}
                  className={`accordion flex-row no-margin${
                    featureActive === id ? ' is-active' : ''
                  }`}>
                  <button
                    type="button"
                    className="button-unstyled accordion-head"
                    onClick={toggleFaqAccordion(id)}>
                    <div className="flex-row no-margin align-items-center">
                      <img src={`/img/${logo}-accordion.svg`} alt="" />
                      <h5>{h}</h5>
                    </div>
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      style={{
                        transform: `translateY(-50%) rotate(${
                          featureActive === id ? '180deg' : '0deg'
                        })`,
                      }}>
                      <path
                        d="M7.41 8.58997L12 13.17L16.59 8.58997L18 9.99997L12 16L6 9.99997L7.41 8.58997Z"
                        fill="#131313"
                      />
                    </svg>
                  </button>
                  <div className="accordion-body">
                    <p>{b}</p>

                    <div className="accordion-img-bg visible-tablet">
                      <span className="big-gradient-circle gradient-anim red-gradient small-gradient" />
                      <span className="big-gradient-circle delay-1 gradient-anim" />
                      <span className="big-gradient-circle delay-2 gradient-anim green-gradient" />
                      <img src={img} alt="" />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="feature-col-2 hidden-tablet">
            <div className="accordion-img-bg position-relative">
              <span className="big-gradient-circle gradient-anim red-gradient small-gradient" />
              <span className="big-gradient-circle delay-1 gradient-anim" />
              <span className="big-gradient-circle delay-2 gradient-anim green-gradient" />
              <div className="accordion-image-area hidden-mobile">
                <div
                  className={`accordion-image1 accordion-image ${
                    featureActive === 0 ? 'accordion-image-active' : ''
                  }`}
                />
                <div
                  className={`accordion-image2 accordion-image ${
                    featureActive === 1 ? 'accordion-image-active' : ''
                  }`}
                />
                <div
                  className={`accordion-image3 accordion-image ${
                    featureActive === 2 ? 'accordion-image-active' : ''
                  }`}
                />
                <div
                  className={`accordion-image4 accordion-image ${
                    featureActive === 3 ? 'accordion-image-active' : ''
                  }`}
                />
                <div
                  className={`accordion-image5 accordion-image ${
                    featureActive === 4 ? 'accordion-image-active' : ''
                  }`}
                />
                <div
                  className={`accordion-image6 accordion-image ${
                    featureActive === 5 ? 'accordion-image-active' : ''
                  }`}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Feature;
